import React from "react";
import { Row, Col } from "reactstrap";

const SelectedEmpConfigMail = React.memo(
  ({ selectedEmp, delSelectedEmp,type }) => {

    return (
      <div className="selected-card">
        {/* <h5>Selected Employee</h5> */}
        <Row className="selected-emp">
          {selectedEmp?.map((el, i) => (
            <Col
              key={i}
              xs={12}
              sm={4}
              md={4}
              lg={4}
              style={{ display: "table" }}
            >
              <div className="selected-emp-info ">
                <div className="emp-img">
                  <img
                    src={el.profilePicture == null || el.profilePicture == "null" || el.profilePicture == 'undefined' || el.profilePicture == 'user.png' || el.profilePicture == '' ? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${el.profilePicture}`)}
                    alt="no img"
                  />
                  <div className="overlay">
                    <div className="text">
                      <i
                        className="fas fa-times user-del-icon"
                        onClick={() => delSelectedEmp(el.toEmpId != null ? (el.toEmpId) : (el.bccEmpId != null ? (el.bccEmpId) : (el.ccEmpId != null ? (el.ccEmpId) : el.employeeId)),type)}
                      ></i>
                    </div>
                  </div>
                </div>

                <span className="emp-name">{el.employeeName}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
);

export default SelectedEmpConfigMail;
